<div fxLayout="column" fxLayoutAlign="center center" class="pb-48 pt-48 pr-56 pl-56">
    @if (dialogData.badge) {
        <div class="pt-8 pr-12 pb-8 pl-12 radius-16 bc-secondary-red-100 t4 c-secondary-red-900">
            {{ dialogData.badge | translate : dialogData.translationParams }}
        </div>
    } @else if (dialogData.icon) {
        <ui-kit-svg class="i-80" [name]="'ic_' + (dialogData.icon | lowercase)"></ui-kit-svg>
    }
    @if (dialogData.title) {
        <div [class.mt-16]="dialogData.badge || dialogData.icon"
             class="h3-semi-bold c-primary-gray-900 pre-line text-center">
            {{ dialogData.title | translate : dialogData.translationParams }}
        </div>
    }
    @if (dialogData.subtitle || dialogData.subtitleHtml) {
        <div [class.mt-16]="dialogData.title"
             class="t3 c-primary-gray-900 pre-line text-center">
            @if (dialogData.subtitleHtml) {
                <span [innerHtml]="dialogData.subtitleHtml | translate : dialogData.translationParams | safeHtml"
                      [commonsClickById]="dialogData.commonsClickById || {}"></span>
            } @else {
                {{ dialogData.subtitle | translate : dialogData.translationParams }}
            }
        </div>
    }
    @if (dialogData.confirmationText) {
        <ui-kit-checkbox [class.mt-16]="dialogData.title || dialogData.subtitle || dialogData.subtitleHtml"
                         appearance="small"
                         [(ngModel)]="confirmationChecked">
            {{ dialogData.confirmationText | translate : dialogData.translationParams }}
        </ui-kit-checkbox>
    }
    <div fxLayout="column" fxLayoutAlign="center center">
        @if (dialogData.buttonOkText) {
            <ui-kit-button class="mt-32"
                           [disabled]="dialogData.confirmationText && !confirmationChecked"
                           [color]="dialogData.isButtonOkAccent && 'accent' || 'primary'"
                           [label]="dialogData.buttonOkText | translate : dialogData.translationParams"
                           (clickListener)="ok()"/>
        }
        @if (dialogData.buttonCancelText) {
            <ui-kit-button type="text"
                           class="mt-16 w-100"
                           [label]="dialogData.buttonCancelText | translate : dialogData.translationParams"
                           (clickListener)="cancel()"/>
        }
    </div>
</div>
